import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="mansionFloor";
export function selectListByQuery(parameter) {
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/selectAll`,
    method: 'get'
  })
}

export function listByMansionId(parameter){
  console.log("params:", parameter)
  return axios({
    url: `/ws/${moduleName}/listByMansionId/${parameter}`,
    method: 'get'
  })
}


export function selectOne(id){
  return axios({
    url: `/ws/${moduleName}/${id}`,
    method: 'get'
  })
}

export function update(parameter) {
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}



export default {
  selectListByQuery,
  listByMansionId,
  selectOne,
  update
}

